module.exports = __webpack_public_path__ + "img/structureImg5.279a5046.png";